import i18n from 'i18n';
import { t } from 'i18next';

export function getTranslatedNews(document_id: string, name: string) {
    return i18n.exists(`web_app.news.${document_id}.${name}`)
        ? t(`web_app.news.${document_id}.${name}`)
        : '';
}
